import AxiosServices from './axios-service';
import {endpoints} from './api-end-points';

export class ParkingService {

  buyParking(body){    
    const res = AxiosServices.post(endpoints.parking.buyParking, body);
    return res;
  }

  getParkings(body, queryString){
    const res = AxiosServices.post(`${endpoints.parking.getParkings}${queryString}`, body);
    return res;
  }

  editParkingPlate(body){    
    const res = AxiosServices.post(endpoints.parking.editParkingPlate, body);
    return res;
  }

  externalizeParking(body){    
    const res = AxiosServices.post(endpoints.parking.externalizeParking, body);
    return res;
  }

  getParkingsByCity(body){    
    const res = AxiosServices.post(endpoints.parking.getParkingsByCity, body);
    return res;
  }
}
const parkingService = new ParkingService();
export default parkingService;
